import { configureStore } from '@reduxjs/toolkit';
import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { perplexityApi } from 'rtkQuery/sharespro/queries/perplexity';
import { companiesPieColorsSlice } from 'slices/modules/companies/companiesPieColors';
import { authSlice } from 'slices/modules/auth/authSlice';
import { widgetChatSlice } from 'slices/modules/chat/widgetChatSlice';

const store = configureStore({
  reducer: {
    [sharesproApi.reducerPath]: sharesproApi.reducer,
    [perplexityApi.reducerPath]: perplexityApi.reducer,
    auth: authSlice.reducer,
    companiesPieColors: companiesPieColorsSlice.reducer,
    selectedChat: widgetChatSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      sharesproApi.middleware,
      perplexityApi.middleware
    ),
});

export type AppStore = typeof store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
